import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreGridColumn } from "@slhuicore/grid-col";
import { style } from "./assets/col.generated-style";

/**
 * Content holder, which must be a direct child of <slh-row>
 * There are 12 template columns available per row, enabling creation of various combinations of elements that span any number of columns
 * Column attributes indicate the number of template columns to span
 * Widths are set in percentages, which ensures consistent relative sizing
 */
@customElement("slh-col")
export default class SlhCol extends SlhCoreGridColumn(LitElement) {
  static styles = style;
}
